import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export const ModelSelector = ({
  value,
  models,
  onChange,
  disabled = false,
  testIdPrefix = "chat-model",
  className,
}) => (
  <div className={cn("min-w-0", className)} data-testid={`${testIdPrefix}-control`}>
    <div
      role="radiogroup"
      aria-label="AI model"
      data-testid={`${testIdPrefix}-selector`}
      style={{ gridTemplateColumns: `repeat(${Math.max(models.length, 1)}, minmax(0, 1fr))` }}
      className="grid min-h-9 min-w-0 items-center gap-0.5 rounded-md border border-input bg-secondary/50 p-0.5"
    >
      {models.map((model) => {
        const selected = value === model.id;
        return (
          <button
            key={model.id}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(model.id)}
            title={model.description}
            data-testid={`${testIdPrefix}-option-${model.id.replaceAll(".", "-")}`}
            className={cn(
              "flex h-7 min-w-0 items-center justify-center gap-1 rounded px-1 text-[9px] sm:text-[10px] font-medium whitespace-nowrap transition-[background-color,color,opacity] disabled:cursor-not-allowed disabled:opacity-50",
              selected ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary hover:text-foreground"
            )}
          >
            {model.id === "auto" && <Sparkles className="h-3 w-3 shrink-0" />}
            {model.short_label || model.label}
          </button>
        );
      })}
    </div>
  </div>
);